<script>
export default {
    name: "custom-checkbox",
    props: {
        hideMargin: {
            type: Boolean,
            default: false,
        },
        checked: {
            type: Boolean,
            default: true,
        },
        dataTest: {
            type: String,
            default: "",
        },
    },
    emits: ["checkbox-click"],
    data() {
        return {
            id: 0,
        };
    },
    methods: {
        emitClick() {
            this.$emit("checkbox-click");
        },
    },
    mounted() {
        this.id = Math.random() * 100;
    },
};
</script>

<template>
    <div class="d-flex flex-row prevent-select cursor-pointer"
         :class="{'mt-2': !hideMargin}"
         @click="emitClick"
         :data-test="dataTest"
    >
        <div class="d-flex flex-row align-self-center">
            <svg
                v-if="!checked"
                width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="15" height="15" fill="white" stroke="#260045"/>
                <defs>
                    <pattern :id="`pattern${id}`" patternContentUnits="objectBoundingBox" width="1" height="1">
                        <use xlink:href="#image0_1871_67628" transform="scale(0.0333333)"/>
                    </pattern>
                    <image id="image0_1871_67628" width="30" height="30"
                           xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAABmJLR0QA/wD/AP+gvaeTAAAAgElEQVRIie2UQQqAIBBF3yWKuv9JWkVYm1x0nFooIRWhpQPRPHCnPmb8IyiK8owamIBOWmqBFRikpBUwe+kCNCpV6X+kPTDiZi+WcE5t4tkdk3hBFimcW9Ym7H39pjHyYkG6kxdP75VcbGSO4ckSpFjCKkU/B3DVGb+KV6oo32QDDxpD3wtiIfoAAAAASUVORK5CYII="/>
                </defs>
            </svg>
            <svg v-if="checked" width="16" height="17" viewBox="0 0 16 17" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="1.5" width="15" height="15" fill="white" stroke="#260045"/>
                <path d="M3.3335 9L6.8335 12.5L12.6668 5.5" stroke="#260045" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>

        <div class="ml-2">
            <slot></slot>
        </div>
    </div>
</template>

<style scoped>

</style>
